// extracted by mini-css-extract-plugin
export default {"imageWrapper":"DH-z","twoColumnImage":"EH-z"};